export const RegexStrings = {
  YOUTUBE_VIDEO_LINK: '^(https?\:\/\/)?((\/\/)?(www\.)?(m.)?youtube\.com|(\/\/)?youtu\.?be)\/.+$',
  AUDIO_LINK: '/\.(mp3|wav|aiff|aac|flac|ogg|wma)$/i'
}
